/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useContext, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  get_assessment_kit_by_id_data_action,
  get_assigned_candidates_to_assessment_kit_action,
  shortlist_candidate_assessment_kit_action,
  reject_candidate_assessment_kit_action,
  search_candidate_action,
  assign_assessment_kit_to_candidate_action,
} from "../../../redux/_actions";

import { showSuccessMessage } from "../../../_uiComponents/ShowMessageSnack";
import { appRoutes } from "../../../_routes/app-routes";
import { ASSESSMENT_ASSIGN_STATUS } from "../../../_constants/AssessmentConst";
import { AuthContext } from "../../../_hooks/useAuthContext";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";
function useViewCandidates() {
  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [isCandidateLoading, setIsCandidateLoading] = useState(false);
  const [assessmentData, setAssessmentData] = useState({});
  const [candidateListData, setCandidateListData] = useState([]);

  const [shortlistRejectType, setShortlistRejectType] = useState(false);
  const [shortlistItem, setshortlistItem] = useState(null);
  const [isShortlistRejectModal, setIsShortlistRejectModal] = useState(false);
  const [remarkText, setRemarkText] = useState("");

  const [suggestedCandidatesLoading, setSuggestedCandidatesLoading] =
    useState(false);
  const [suggestedCandidates, setSuggestedCandidates] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [assignmentUserId, setAssignmentUserId] = useState(null);
  const [isInvitationModal, setIsInvitationModal] = useState(false);
  const [isInviteSuccessModal, setIsInviteSuccessModal] = useState(false);
  const [isCreateAssessmentModal, setIsCreateAssessmentModal] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const searchInputRef2 = useRef();

  const { createAssessmentData } = useSelector(
    (state) => state.create_assessment_kit_reducer
  );

  const { assessmentKitCandidatesData } = useSelector(
    (state) => state.get_assigned_candidates_to_assessment_kit_reducer
  );
  const { searchCandidateData } = useSelector(
    (state) => state.search_candidate_reducer
  );

  useEffect(() => {
    if (createAssessmentData) {
      setAssessmentData(createAssessmentData);
    }
    if (Array.isArray(createAssessmentData?.skills)) {
      let skills = createAssessmentData.skills.map(
        (item) => item?.skill_id?.skill
      );
      getSuggestedCandidatesApi(skills);
    }
  }, [createAssessmentData]);

  useEffect(() => {
    if (assessmentKitCandidatesData) {
      setCandidateListData(assessmentKitCandidatesData);
    }
  }, [assessmentKitCandidatesData]);

  useEffect(() => {
    if (searchCandidateData?.data) {
      setSuggestedCandidates(searchCandidateData?.data);
    }
  }, [searchCandidateData]);

  useEffect(() => {
    window.scroll(0, 0);
    let id = params?.id;

    if (id) callApi(id);
  }, []);

  const onEditKitClick = (id) => {
    navigate(appRoutes.assessementKit.viewAssessment.replace(":id", id));
  };

  const callApi = async (id) => {
    setLoading(true);
    await dispatch(get_assessment_kit_by_id_data_action(id));
    await dispatch(get_assigned_candidates_to_assessment_kit_action(id, ""));
    setLoading(false);
  };

  const onAssessmentShareClick = (hash_id) => {
    const isDev =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";

    if (hash_id) {
      const url = isDev
        ? `http://localhost:3000${appRoutes.assessementKit.assessmentPublicDetails.replace(
            ":id",
            hash_id
          )}`
        : `${
            process.env.REACT_APP_DEV_ROOT_URL
          }${appRoutes.assessementKit.assessmentPublicDetails.replace(
            ":id",
            hash_id
          )}`;
      window.navigator.clipboard.writeText(url);

      showSuccessMessage(`Url copied ${url}`);
    }
  };

  const getStatusCount = (status) => {
    if (Array.isArray(assessmentData?.status_count)) {
      let statusCount = assessmentData.status_count.filter(
        (item) => item.status === status
      );

      return (statusCount && statusCount[0]?.count) || 0;
    }
    return 0;
  };

  const onViewCandidateResponseClick = (id) => {
    navigate(
      appRoutes.assessementKit.candidateAssessmentView.replace(
        ":assessmentId",
        id
      )
    );
  };

  const onTabchangeHandler = async (e) => {
    const status = e === "all" ? "" : e;
    let id = params?.id;
    if (id) {
      setIsCandidateLoading(true);
      if (status !== "suggested")
        await dispatch(
          get_assigned_candidates_to_assessment_kit_action(id, status)
        );
      setIsCandidateLoading(false);
    }
  };

  const shortlistRejectClick = async () => {
    if (remarkText === "") {
      showWarningMessage("Please Enter Remark");
    } else {
      if (shortlistRejectType === ASSESSMENT_ASSIGN_STATUS.shortlisted) {
        await dispatch(
          shortlist_candidate_assessment_kit_action(shortlistItem?.id)
        );
      } else if (shortlistRejectType === ASSESSMENT_ASSIGN_STATUS.rejected) {
        await dispatch(
          reject_candidate_assessment_kit_action(shortlistItem?.id)
        );
      }
    }
  };

  const handleShortlistRejectModal = (val, id) => {
    setIsShortlistRejectModal((v) => !v);
    setShortlistRejectType(val);
    setshortlistItem(id);
  };

  const onBlurInput = (e) => {
    setRemarkText(e.target.value);
  };

  const getSuggestedCandidatesApi = async (skills) => {
    const data = {
      index: "candidate_profile",
      search_key: "",
      search: "",
      skill_names: skills ? skills : "",
    };
    setSuggestedCandidatesLoading(true);
    await dispatch(search_candidate_action(data));
    setSuggestedCandidatesLoading(false);
  };

  const handleInvitationModal = (id) => {
    setIsInvitationModal(!isInvitationModal);
    setAssignmentUserId(id);
  };
  const handleInviteSuccessModal = () => {
    setIsInvitationModal(false);
    setIsInviteSuccessModal(!isInviteSuccessModal);
  };
  const handleCreateAssessmentModal = () => {
    setIsInvitationModal(false);
    setIsCreateAssessmentModal(!isCreateAssessmentModal);
  };

  const onAssignAssessmentClick = async (assessmentId) => {
    const data = {
      assessment_id: assessmentId,
      candidate_id: assignmentUserId,
    };

    await dispatch(assign_assessment_kit_to_candidate_action(data));
    setAssignmentUserId(null);
    setIsInvitationModal(false);
  };

   const totalCandidates = () => {
    const acceptedCandidates = getStatusCount("accepted")
    const completedCandidates = getStatusCount("completed")
    const assignedCandidates = getStatusCount("assigned")
    const shortlistedCandidates = getStatusCount("shortlisted")

    const allCandidates = Number(acceptedCandidates) + Number(completedCandidates) + Number(assignedCandidates) + Number(shortlistedCandidates)

    return allCandidates;
};

  return {
    assessmentData,
    candidateListData,
    loading,
    isCandidateLoading,
    user,
    isShortlistRejectModal,
    shortlistRejectType,
    onBlurInput,
    shortlistRejectClick,
    handleShortlistRejectModal,
    onTabchangeHandler,
    onEditKitClick,
    onAssessmentShareClick,
    onViewCandidateResponseClick,
    getStatusCount,

    isInvitationModal,
    handleInvitationModal,
    handleInviteSuccessModal,
    isInviteSuccessModal,
    isCreateAssessmentModal,
    handleCreateAssessmentModal,
    onAssignAssessmentClick,
    assignmentUserId,
    suggestedCandidates,
    showSearch,
    searchInputRef2,
    totalCandidates
  };
}

export default useViewCandidates;
